import React from 'react';
import Navbar from '../components/Navbar';
import RegistroIngresos from '../components/registrosIngresos/RegistroIngresos';

const Registros = () => {
    return (
        <div>
            <Navbar />
            <RegistroIngresos />
        </div>
    );
};

export default Registros;